'use client';

import { c as _c } from "react/compiler-runtime";
import { Heart, HeartSolid } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { CenteredModal } from '~/components/CenteredModal';
import { SAVE_TRIP_TRACKING_ID } from '~/components/Common/SaveButton/src/useSaveTrip';
import { Divider } from '~/components/Divider';
import { OverlayDrawer } from '~/components/Drawer';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import { useTripSave } from '~/hooks/useTripSave';
import { trackEvent } from '~/utils';
import styles from './SaveTripButton.module.css';
type SaveTripButtonProps = {
  tripId: string | null | undefined;
  className: string;
  size: 'small' | 'large';
  iconVariant?: 'default' | 'overviewIntro';
};
export const SaveTripButton = t0 => {
  const $ = _c(56);
  const {
    tripId,
    className,
    size,
    iconVariant: t1
  } = t0;
  const iconVariant = t1 === undefined ? "default" : t1;
  const t = useTranslations("journey");
  const tAccount = useTranslations("account");
  const {
    isTripSaved,
    isPending,
    isLoginOpen,
    setIsLoginOpen,
    handleSave,
    handleLogin
  } = useTripSave(tripId);
  const isDesktop = useIsDesktop();
  const iconSize = iconVariant === "overviewIntro" ? "small" : size;
  let t2;
  if ($[0] !== tAccount) {
    t2 = tAccount("save_defer");
    $[0] = tAccount;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const heading = t2;
  let t3;
  if ($[2] !== setIsLoginOpen) {
    t3 = () => setIsLoginOpen(false);
    $[2] = setIsLoginOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const close = t3;
  let t4;
  if ($[4] !== tAccount) {
    t4 = tAccount("defer");
    $[4] = tAccount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== close || $[7] !== t4) {
    t5 = <Button onPress={close} size="fullWidth" variant="tertiary" isPillShape={true} dataTestId="SaveTripLoginDefer">{t4}</Button>;
    $[6] = close;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== tAccount) {
    t6 = tAccount("log_in");
    $[9] = tAccount;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleLogin || $[12] !== t6) {
    t7 = <Button onPress={handleLogin} size="fullWidth" isPillShape={true} dataTestId="SaveTripLoginConfirm">{t6}</Button>;
    $[11] = handleLogin;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className={styles.actions}>{t5}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const actions = t8;
  const t9 = isDesktop && styles.bodyModal;
  let t10;
  if ($[17] !== t9) {
    t10 = clsx(styles.body, t9);
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== heading) {
    t11 = <h2 className={styles.heading}>{heading}</h2>;
    $[19] = heading;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== tAccount) {
    t12 = tAccount("login_prompt_save");
    $[21] = tAccount;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <p className={styles.text}>{t12}</p>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== actions || $[26] !== isDesktop) {
    t14 = isDesktop ? <div className={styles.footerModal}><Divider variant="horizontal" />{actions}</div> : actions;
    $[25] = actions;
    $[26] = isDesktop;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t13 || $[31] !== t14) {
    t15 = <div className={t10}>{t11}{t13}{t14}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const body = t15;
  let t16;
  if ($[33] !== t) {
    t16 = t("overview_save_trip");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = isPending || undefined;
  const t18 = isPending || undefined;
  let t19;
  if ($[35] !== handleSave) {
    t19 = () => {
      trackEvent(SAVE_TRIP_TRACKING_ID, {
        event_category: "click",
        event_label: SAVE_TRIP_TRACKING_ID
      });
      handleSave();
    };
    $[35] = handleSave;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== iconSize || $[38] !== isTripSaved) {
    t20 = isTripSaved ? <HeartSolid decorative={true} isInline={true} size={iconSize} /> : <Heart decorative={true} isInline={true} size={iconSize} />;
    $[37] = iconSize;
    $[38] = isTripSaved;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== className || $[41] !== t16 || $[42] !== t17 || $[43] !== t18 || $[44] !== t19 || $[45] !== t20) {
    t21 = <button type="button" className={className} aria-label={t16} aria-disabled={t17} aria-busy={t18} onClick={t19}>{t20}</button>;
    $[40] = className;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== body || $[48] !== close || $[49] !== heading || $[50] !== isDesktop || $[51] !== isLoginOpen) {
    t22 = isDesktop ? <CenteredModal ariaLabel={heading} close={close} closeDataTestId="SaveTripLoginModalClose" dataTestId="SaveTripLoginModal" fitContent={true} isOpen={isLoginOpen} size="medium">{body}</CenteredModal> : <OverlayDrawer isOpen={isLoginOpen} close={close} ariaLabel={heading} dataTestId="SaveTripLoginDrawer">{body}</OverlayDrawer>;
    $[47] = body;
    $[48] = close;
    $[49] = heading;
    $[50] = isDesktop;
    $[51] = isLoginOpen;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t21 || $[54] !== t22) {
    t23 = <>{t21}{t22}</>;
    $[53] = t21;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  return t23;
};